// extracted by mini-css-extract-plugin
module.exports = {"invoiceDescr":"InvoiceDescriptionValue_invoiceDescr__qydRa"};